// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"e36d7f54","726":"e7cac271","943":"0a84ba6d"}[chunkId] + ".chunk.js";
};